import { render } from "./BlurtingForm.vue?vue&type=template&id=19fef5c3&scoped=true"
import script from "./BlurtingForm.vue?vue&type=script&lang=js"
export * from "./BlurtingForm.vue?vue&type=script&lang=js"

import "./BlurtingForm.vue?vue&type=style&index=0&id=19fef5c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fef5c3"]])

export default __exports__